import { showTitle } from '@/libs/util'
export default {
  components: {
    
  },
  created(){
  },
  methods: {

    showTitle (item) {
      // console.log(item)
      // return item.name
      return showTitle(item, this)
    },
    showChildren (item) {
      return item.children && item.children.length >1
    },
    getNameOrHref (item, children0) {
      return item.href ? `isTurnByHref_${item.href}` : (children0 ? item.children[0].name : item.name)
    }
  }
}
